import isArray from 'lodash/isArray';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '@/store/redux';

const parseReduxStateLocalStorage = (localStorageKey: string) => {
  if (typeof window === 'undefined') return null;

  const storageValue = localStorage.getItem(localStorageKey) || '';

  return storageValue ? JSON.parse(storageValue) : null;
};

const isEmptyStoredObject = (stateObject: any) => {
  return Object.values(stateObject).every((value) => {
    if (value === null) return true;
    if (value === '') return true;
    if (isArray(value) && value.length === 0) return true;

    return false;
  });
};

export const useReduxPersistLocalStorage = (
  persistKey: keyof RootState['pages'],
  updateState: (value: any) => void
) => {
  const dispatch = useDispatch();

  const persistState = useSelector((state: RootState) => {
    if (persistKey === 'serviceBooking') {
      return state.pages.serviceBooking.page;
    } else {
      return state.pages[persistKey];
    }
  });

  const parsedPersistState = useMemo(
    () =>
      typeof persistKey === 'string' && parseReduxStateLocalStorage(persistKey),
    [persistKey]
  );

  useEffect(() => {
    if (
      parsedPersistState &&
      !isEmptyStoredObject(parsedPersistState) &&
      typeof persistKey === 'string'
    ) {
      dispatch(updateState(parsedPersistState));
      localStorage.removeItem(persistKey);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      (persistState && isEmptyStoredObject(persistState)) ||
      typeof persistKey !== 'string'
    )
      return;

    localStorage.setItem(persistKey, JSON.stringify(persistState));
  }, [persistKey, persistState]);
};
